import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Drawer,
} from 'antd';
import { DownloadOutlined, EditOutlined, MailOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import SellerActions from '@Actions/sellerActions';
import H3Text from '@Uilib/h3Text';
import H3DateSelector from '@Uilib/h3DateSelector';
import Helpers from '@Apis/helpers';
import ViewPayment from '@Components/Common/ViewPayment';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Image from '@Uilib/h3Image';
import Constants from '@Apis/constants';
import SendVendorMail from './SendVendorMail';
import './style.scss';
import PRZButton from '../../../Common/UI/PRZButton';
import LedgerEntryForm from '../../../Common/LedgerEntryForm';

/**
 *
*/

const AccountStatement = ({
  getReports, user, selectedSeller, accountStatement, getReportsLoading, history, MONEY,
}) => {
  const [showViewPayout, setShowViewPayout] = useState(false);
  const [paymentId, setPaymentId] = useState('');
  const [call, setCall] = useState(false);
  const [showCreateLedgerDrawer, setShowCreateLedgerDrawer] = useState(false);
  const [selectLedgerEntry, setSelectLedgerEntry] = useState(null);
  const [isUpdateLedgerEntry, setIsUpdateLedgerEntry] = useState(false);

  const handleRedirect = (record, type) => {
    if (record.entity_type === 'GOOD_RECEIVING_NOTE') {
      history.push(`/purchase/goods-receiving/view/${record?.entity_id}`);
    }
    if (record.entity_type === 'INVOICE') {
      history.push(`/sales/invoice/view/${record?.entity_id}`);
    }
    if (record.entity_type === 'CREDIT_NOTE') {
      history.push(`/sales/credit-note/view/${record?.entity_id}`);
    }
    if (record.entity_type === 'VENDOR_PAYMENT') {
      setShowViewPayout(true);
      setPaymentId(record.entity_id);
    }
    if (record.entity_type === 'DEBIT_NOTE') {
      history.push(`/purchase/debit-note/view/${record?.entity_id}`);
    }
  };
  const [selectedInterval, setSelectedInterval] = useState('this_month');
  const [showEmailDrawer, setShowEmailDrawer] = useState(false);
  const [startDateMomentEpoch, setStartDateMomentEpoch] = useState(dayjs().startOf('month').valueOf());
  const [endDateMomentEpoch, setEndDateMomentEpoch] = useState(dayjs().endOf('month').valueOf());
  const [purchaseLedgerColumns] = useState([
    {
      title: 'DATE',
      render: (record) => <H3Text text={record?.created_at ? `${dayjs(record?.created_at).format('DD/MM/YYYY')}` : ''} className="prod-table__text" />,
    },
    {
      title: 'TRANSACTIONS',
      render: (record) => <H3Text text={['OPENING_BALANCE', 'BALANCE'].includes(record?.entity_type) ? `***${Helpers.snakeCaseToNormal(record?.entity_type)?.toProperCase()}***` : `${!['VENDOR_PAYMENT', 'CUSTOMER_PAYMENT'].includes(record?.entity_type) ? Helpers.snakeCaseToNormal(record?.entity_type)?.toProperCase() : `${record?.entity_type === 'VENDOR_PAYMENT' ? 'Outgoing Payment' : 'Incoming Payment'}`}`} className="prod-table__text" />,
    },
    {
      title: 'DETAILS',
      render: (record) => (
        <Fragment>
          <div>
            {record?.grn_payments?.length > 0 ? (
              <div>
                <div className="statement__deleted-transaction-wrapper">
                  {record?.is_deleted ? (
                    <span className="link-text-disabled">
                      {record?.reference_number || record.entity_id}

                    </span>
                  )
                    : (
                      <span className="link" onClick={() => handleRedirect(record)}>
                        {record?.reference_number || record.entity_id}

                      </span>
                    )}
                  <span>{record?.is_deleted && <H3Text text="Deleted" className="statement__deleted-transaction" />}</span>
                </div>
                {record?.grn_payments?.map((grn, idx) => (
                  <div key={idx}>
                    <span>
                      {MONEY(grn?.amount)}
                    </span>
                    &nbsp;linked to&nbsp;
                    <span className="link" onClick={() => history.push(`/purchase/goods-receiving/view/${grn?.grn_id}`)}>{grn?.grn_number}</span>
                  </div>
                ))}
                {record?.po_payments ? (
                  <div>
                    <span>
                      {MONEY(Number(record?.po_payments?.unused_amount) || 0)}
                    </span>
                    &nbsp;linked to&nbsp;
                    <span className="link" onClick={() => history.push(`/approval?type=po&id=${record?.po_payments?.po_id}`)}>{record?.po_payments?.po_number}</span>
                  </div>
                ) : ''}
              </div>
            )
              : (
                <Fragment>
                  <div className="statement__deleted-transaction-wrapper">
                    {record?.is_deleted ? (
                      <span className="link-text-disabled">
                        {record?.reference_number || record.entity_id}

                      </span>
                    )
                      : (
                        <span className="link" onClick={() => handleRedirect(record)}>
                          {record?.entity_type !== 'ACCOUNT_PAYABLE_INVOICE' && (record?.reference_number || record.entity_id)}
                        </span>
                      )}
                    <span>{record?.is_deleted && <H3Text text="Deleted" className="statement__deleted-transaction" />}</span>
                  </div>
                  {record?.po_payments ? (
                    <div>
                      <span>
                        {MONEY(Number(record?.po_payments?.unused_amount) || 0)}
                      </span>
                      &nbsp;linked to&nbsp;
                      <span className="link" onClick={() => history.push(`/approval?type=po&id=${record?.po_payments?.po_id}`)}>{record?.po_payments?.po_number}</span>
                    </div>
                  ) : ''}
                  {record?.entity_type === 'ACCOUNT_PAYABLE_INVOICE' && !record?.is_deleted ? (
                    <div>
                      <span className="link" onClick={() => history.push(`/purchase/account-payable-invoice/view/${record?.entity_id}`)}>{record?.reference_number}</span>
                    </div>
                  ) : ''}

                </Fragment>

              )}
          </div>
        </Fragment>
      ),
    },
    {
      title: 'PAYMENT REF',
      render: (record) => (
        <div>
          <H3Text text={record?.payment_ref || '-'} className="" />
        </div>
      ),
    },
    {
      title: 'BILL NUMBER',
      render: (record) => (
        <div>
          <H3Text text={record?.invoice_number || '-'} className="" />
        </div>
      ),
    },
    {
      title: 'CREDIT',
      render: (record) => (
        <Fragment>
          <div>
            {record?.transaction_type === 'CREDIT' ? MONEY(record?.transaction_amount) : '-'}
          </div>
        </Fragment>
      ),
    },
    {
      title: 'DEBIT',
      render: (record) => (
        <div>
          {record?.transaction_type === 'DEBIT' ? MONEY(record?.transaction_amount) : '-'}
        </div>
      ),
    },
    {
      title: 'BALANCE',
      render: (record) => (
        <div>
          <H3Text text={MONEY(record?.current_amount)} className="link" />
        </div>
      ),
    },
    {
      title: '',
      render: (record) => (
        (record?.entity_type === 'MANUAL_ENTRY') ? (
          <div>
            <EditOutlined
              onClick={() => {
                setIsUpdateLedgerEntry(true);
                setSelectLedgerEntry(record);
                setShowCreateLedgerDrawer(true);
              }}
              style={{ color: 'rgb(48, 134, 255)' }}
            />
          </div>
        ) : ''
      ),
    },

  ]);

  useEffect(() => {
    if (user && selectedSeller && user?.tenant_info?.org_id) {
      getReports('seller-ledger', '', selectedSeller?.tenant_id, selectedSeller?.seller_id, startDateMomentEpoch, endDateMomentEpoch);
    }
  }, [selectedSeller, call]);

  const getDataSource = () => {
    if (accountStatement?.ledger && accountStatement?.ledger?.length > 0) {
      return [{
        entity_type: 'OPENING_BALANCE',
        created_at: startDateMomentEpoch,
        current_amount: accountStatement?.ledger?.[0]?.previous_amount,
      }, ...accountStatement.ledger, {
        entity_type: 'BALANCE',
        created_at: endDateMomentEpoch,
        current_amount: accountStatement?.ledger?.[accountStatement?.ledger?.length - 1]?.current_amount,
      }];
    }
    return [];
  };
  /**
   *
   * @param {*} startDateMomentEpoch
   * @param {*} endDateMomentEpoch
   */
  const loadReportsDownloadData = () => {
    const formDateWithoutMilliSec = Number((startDateMomentEpoch / 1000).toFixed(0));
    const toDateWithoutMilliSec = Number((endDateMomentEpoch / 1000).toFixed(0));
    let url = `${Constants.SELLERS_REPORT_DOWNLOAD}/seller-ledger?tenant_id=${user?.tenant_info?.tenant_id}&seller_id=${selectedSeller?.seller_id}&type=download&`;
    if (startDateMomentEpoch) url += `from=${formDateWithoutMilliSec}&`;
    if (endDateMomentEpoch) url += `to=${toDateWithoutMilliSec}&`;
    return url;
  };

  const resetLedgerEntryFormDrawer = () => {
    setSelectLedgerEntry(null);
    setIsUpdateLedgerEntry(false);
    setShowCreateLedgerDrawer(false);
  };

  return (
    <Fragment>
      <div className="account-ledger__wrapper">
        <div className="ant-row">
          <div className="account-ledger-header">
            <div className="account-ledger-summary__wrapper account-ledger-summary__bg">
              <div className="">
                <div className="flex-jc">
                  <div className="account-summary__field-name">Opening Balance </div>
                  <div className="account-summary__field-value">
                    {MONEY(accountStatement?.ledger?.[0]?.previous_amount || 0)}
                  </div>

                </div>
                <div className="flex-jc">
                  <div className="account-summary__field-name">Billed Amount </div>
                  <div className="account-summary__field-value">
                    {MONEY(accountStatement?.account_summary?.billed_amount || 0)}
                  </div>
                </div>
                <div className="flex-jc">

                  <div className="account-summary__field-name"> Amount Paid</div>
                  <div className="account-summary__field-value">
                    {MONEY(accountStatement?.account_summary?.amount_paid || 0)}
                  </div>
                </div>
              </div>
              <hr className="hr-margin" />
              <div className="flex-jc">
                <div className="account-summary__field-name bold"> Balance Due</div>
                <div className="account-summary__field-value bold">
                  {MONEY(accountStatement?.account_summary?.balance || 0)}
                </div>
              </div>
            </div>
            <div className="account-ledger-summary__right">
              <div className="account-ledger-summary__right_top">
                {accountStatement?.ledger?.length > 0 && (
                  <div className="report-header__action-btn">
                    <H3Text
                      text={(
                        <a href={loadReportsDownloadData()} target="_blank" rel="noreferrer">
                          <DownloadOutlined />
                        </a>
                      )}
                      className="action-button"
                    />
                    <H3Text
                      text={(
                        <div onClick={() => setShowEmailDrawer(true)}>
                          <MailOutlined />
                        </div>
                      )}
                      className="action-button"
                    />
                  </div>
                )}
                <div className="">
                  <H3DateSelector
                    selectedInterval={selectedInterval}
                    startDate={startDateMomentEpoch}
                    endDate={endDateMomentEpoch}
                    onDateChange={(date) => {
                      setStartDateMomentEpoch(dayjs(date[0])?.valueOf());
                      setEndDateMomentEpoch(dayjs(date[1])?.valueOf());
                      setSelectedInterval('customize');
                      setCall(!call);
                    }}
                  />
                </div>
              </div>
              <div className="account-ledger-summary__right_bottom">
                <PRZButton
                  type="primary"
                  onClick={() => {
                    setShowCreateLedgerDrawer(true);
                  }}
                  disabled={!selectedSeller}
                >
                  + Add Ledger Entry
                </PRZButton>
              </div>
            </div>
          </div>
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="generic-table-container">
              <Table
                loading={getReportsLoading}
                showHeader
                size="small"
                scroll="scroll"
                columns={purchaseLedgerColumns}
                rowKey="po_id"
                dataSource={getDataSource(accountStatement)}
                pagination={false}
                rowClassName={(record) => (record?.is_deleted ? 'row-disabled' : '')}
              />
            </div>
          </div>
        </div>
        <Drawer
          open={showViewPayout}
          onClose={() => setShowViewPayout(false)}
          width="880px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '825px' }}>
              <H3Text text={`View Payment #${paymentId}`} className="custom-drawer__title" />
              <H3Image
                src={closeIcon}
                className="custom-drawer__close-icon"
                onClick={() => setShowViewPayout(false)}
              />
            </div>
          </div>
          <ViewPayment
            selectedPaymentId={paymentId}
            callback={() => {
              setShowViewPayout(false);
              getReports('seller-ledger', '', selectedSeller?.tenant_id, selectedSeller?.seller_id, startDateMomentEpoch, endDateMomentEpoch);
            }}
          />
        </Drawer>
        <Drawer
          open={showEmailDrawer}
          width="420px"
          mask
          onClose={() => setShowEmailDrawer(false)}
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '375px' }}>
              <H3Text text="Send Account Statement to Vendor" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowEmailDrawer(false)} />
            </div>
          </div>
          <SendVendorMail startDateMomentEpoch={startDateMomentEpoch} endDateMomentEpoch={endDateMomentEpoch} callback={() => setShowEmailDrawer(false)} />
        </Drawer>

        <Drawer
          open={showCreateLedgerDrawer}
          width="420px"
          mask
          onClose={() => {
            resetLedgerEntryFormDrawer();
          }}
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '375px' }}>
              <H3Text text={isUpdateLedgerEntry ? 'Update Ledger Entry' : 'Add New Ledger Entry'} className="custom-drawer__title" />
              <H3Image
                src={closeIcon}
                className="custom-drawer__close-icon"
                onClick={() => {
                  resetLedgerEntryFormDrawer();
                }}
              />
            </div>
          </div>
          <LedgerEntryForm
            selectedSeller={selectedSeller}
            selectLedgerEntry={selectLedgerEntry}
            isUpdateLedgerEntry={isUpdateLedgerEntry}
            callback={() => {
              resetLedgerEntryFormDrawer();
              setCall(!call);
            }}
          />
        </Drawer>
      </div>
    </Fragment>
  );
};
const mapStateToProps = ({ UserReducers, SellerReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  accountStatement: SellerReducers.accountStatement,
  getReportsLoading: SellerReducers.getReportsLoading,
  getDownloadReportsLoading: SellerReducers.getDownloadReportsLoading,
  selectedSeller: SellerReducers.selectedSeller,
});
const mapDispatchToProps = (dispatch) => ({
  getReports: (firstSubUrl, secondSubUrl, tenantId, sellerId, fromDate, toDate) => dispatch(SellerActions.getReports(firstSubUrl, secondSubUrl, tenantId, sellerId, fromDate, toDate)),
  getDownloadReports: (firstSubUrl, secondSubUrl, tenantId, tenantSellerId, fromDate, toDate, fileReportType) => dispatch(SellerActions.getDownloadReports(firstSubUrl, secondSubUrl, tenantId, tenantSellerId, fromDate, toDate, fileReportType)),
});
AccountStatement.propTypes = {
  user: PropTypes.any,
  getDownloadReports: PropTypes.func,
  getReports: PropTypes.func,
  getReportsLoading: PropTypes.bool,
  accountStatement: PropTypes.any,
  selectedSeller: PropTypes.any,
  history: PropTypes.func,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AccountStatement));
